export const TENANT_NOT_FOUND = 'Tenant not found';
